/**
 * ISSUE-1057. The chooser behind the composer's single Attach button. A
 * fourth 44 px icon in the composer row would squeeze the text box to a few
 * pixels at 320 px, so photo and PDF share one button and pick here.
 * ISSUE-1365 adds "Share a game", which opens the game picker.
 */
import { Dialog } from "@sportsmet/ui";
import type { ReactNode } from "react";

import {
  COMPOSER_ATTACH_TITLE,
  COMPOSER_PDF_ACTION_LABEL,
  COMPOSER_PHOTO_ACTION_LABEL,
} from "./chatExtrasCopy";
import { COMPOSER_GAME_ACTION_LABEL } from "./gamePickerLogic";

export type typeComposerAttachDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  isPhotoDisabled: boolean;
  isPdfDisabled: boolean;
  onPickPhoto: () => void;
  onPickPdf: () => void;
  /**
   * ISSUE-1365. Opens the game picker. Left out, the row is not drawn. It
   * sends its own messages, so a staged photo or PDF never blocks it.
   */
  onPickGame?: (() => void) | undefined;
};

const ROW_CLASS =
  "flex min-h-touch-target w-full items-center px-4 text-left text-body disabled:opacity-40";

export const ComposerAttachDialog = (
  props: typeComposerAttachDialogProps,
): ReactNode => {
  return (
    <Dialog
      open={props.open}
      onOpenChange={props.onOpenChange}
      title={COMPOSER_ATTACH_TITLE}
      autoFocus={false}
    >
      <div className="flex flex-col">
        {/* The pick callback runs first and synchronously, so the browser
            still counts the hidden input's click as user initiated. */}
        <button
          type="button"
          data-testid="composer-attach-photo"
          disabled={props.isPhotoDisabled}
          onClick={() => {
            props.onPickPhoto();
            props.onOpenChange(false);
          }}
          className={ROW_CLASS}
        >
          {COMPOSER_PHOTO_ACTION_LABEL}
        </button>
        <button
          type="button"
          data-testid="composer-attach-pdf"
          disabled={props.isPdfDisabled}
          onClick={() => {
            props.onPickPdf();
            props.onOpenChange(false);
          }}
          className={ROW_CLASS}
        >
          {COMPOSER_PDF_ACTION_LABEL}
        </button>
        {props.onPickGame !== undefined ? (
          <button
            type="button"
            data-testid="composer-attach-game"
            onClick={() => {
              props.onOpenChange(false);
              props.onPickGame?.();
            }}
            className={ROW_CLASS}
          >
            {COMPOSER_GAME_ACTION_LABEL}
          </button>
        ) : null}
      </div>
    </Dialog>
  );
};
